"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const app_platform_i18n_core_1 = require("@semios/app-platform-i18n-core");
const zod_1 = require("zod");
const _utils_1 = require("../../_utils");
const shared_types_1 = require("../../shared-types");
const FIRST_NAME_LENGTH_MIN = 1;
const FIRST_NAME_LENGTH_MAX = 150;
const LAST_NAME_LENGTH_MIN = 1;
const LAST_NAME_LENGTH_MAX = 150;
const PASSWORD_LENGTH_MIN = 6;
const PASSWORD_LENGTH_MAX = 200;
const requestSchema = (validationPhrases) => zod_1.z.object({
    selfRegistrationHash: zod_1.z.string().trim().min(1),
    email: zod_1.z.string().trim().email((0, _utils_1.invalidMessageMaker)(validationPhrases, 'Email')),
    firstName: zod_1.z
        .string()
        .trim()
        .min(FIRST_NAME_LENGTH_MIN, validationPhrases('{{label}} must be >= {{value}}', {
        label: validationPhrases('First Name'),
        value: validationPhrases('{{count}} character(s)', { count: FIRST_NAME_LENGTH_MIN }),
    }))
        .max(FIRST_NAME_LENGTH_MAX, validationPhrases('{{label}} must be <= {{value}}', {
        label: validationPhrases('First Name'),
        value: validationPhrases('{{count}} character(s)', { count: FIRST_NAME_LENGTH_MAX }),
    })),
    lastName: zod_1.z
        .string()
        .trim()
        .min(LAST_NAME_LENGTH_MIN, validationPhrases('{{label}} must be >= {{value}}', {
        label: validationPhrases('Last Name'),
        value: validationPhrases('{{count}} character(s)', { count: LAST_NAME_LENGTH_MIN }),
    }))
        .max(LAST_NAME_LENGTH_MAX, validationPhrases('{{label}} must be <= {{value}}', {
        label: validationPhrases('Last Name'),
        value: validationPhrases('{{count}} character(s)', { count: LAST_NAME_LENGTH_MAX }),
    })),
    language: zod_1.z.enum(app_platform_i18n_core_1.I18nCore.LANGUAGES, (0, _utils_1.enumMessagesMaker)(validationPhrases, 'Language')),
    password: zod_1.z
        .string()
        .trim()
        .min(PASSWORD_LENGTH_MIN, validationPhrases('{{label}} must be >= {{value}}', {
        label: validationPhrases('Password'),
        value: validationPhrases('{{count}} character(s)', { count: PASSWORD_LENGTH_MIN }),
    }))
        .max(PASSWORD_LENGTH_MAX, validationPhrases('{{label}} must be <= {{value}}', {
        label: validationPhrases('Password'),
        value: validationPhrases('{{count}} character(s)', { count: PASSWORD_LENGTH_MAX }),
    })),
    country: zod_1.z.enum(['AU', 'CA', 'DE', 'ES', 'FR', 'IT', 'NL', 'US', 'Other'], (0, _utils_1.enumMessagesMaker)(validationPhrases, 'Country')),
    unitSystem: zod_1.z.enum(['IMPERIAL', 'METRIC'], (0, _utils_1.enumMessagesMaker)(validationPhrases, 'Unit System')),
    appMeta: shared_types_1.appMetaSchema.optional(), // TODO: should we i18n'ify this?
    optInForMarketingEmails: zod_1.z.boolean(),
});
exports.requestSchema = requestSchema;
exports.path = '/self-registration-submission';
//# sourceMappingURL=index.js.map